import { DEFAULT_ERROR_MESSAGE } from '../../common/constants/error';

export class SimpleMessageError extends Error {
  message: string;

  constructor(message: string = DEFAULT_ERROR_MESSAGE) {
    super();
    this.message = message;
  }
}
